import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RequireAuth from "../auth/RequireAuth";
import LeagueShell from "./components/LeagueShell";
import LeagueHome from "./pages/LeagueHome";
import LeagueAdmin from "./pages/LeagueAdmin";
import LeagueFixtures from "./pages/LeagueFixtures";
import ClubProfile from "./pages/ClubProfile";
import SeasonArchive from "./pages/SeasonArchive";
import LeaguePermissionGate from "./components/LeaguePermissionGate";
import "./styles/league.css";

export default function LeagueApp() {
  return (
    <RequireAuth orgRequired appRequired="league">
      <Routes>
        <Route element={<LeagueShell />}>
          <Route index element={<LeagueHome />} />
          <Route path="table" element={<LeagueHome initialSection="standings" />} />
          <Route path="events" element={<LeagueFixtures mode="viewer" />} />
          <Route path="fixtures" element={<LeagueFixtures mode="viewer" />} />
          <Route path="admin/events" element={<LeaguePermissionGate permission="manage_season"><LeagueFixtures mode="admin" /></LeaguePermissionGate>} />
          <Route path="clubs/:clubId" element={<ClubProfile />} />
          <Route path="archive" element={<SeasonArchive />} />
          <Route path="admin" element={<LeaguePermissionGate permission="manage_season"><LeagueAdmin /></LeaguePermissionGate>} />
          <Route path="*" element={<Navigate to="/league" replace />} />
        </Route>
      </Routes>
    </RequireAuth>
  );
}
